import React from 'react';
import { Modal } from '../../components';
import { manageDisableScrolling } from '../../ducks/ui.duck';
import ProfileIconCard from '../ProfileIconCard/ProfileIconCard';
import { createResourceLocatorString } from '../../util/routes';
import css from './SeeAllGroupModal.module.css';
const SeeAllGroupModal = props => {
  const { onSeeAllGroupClick, isSeeAllGroup, spaceListData, history, routeConfiguration } = props;
  const fetchSpaceDetails = space => {
    const { id, slug } = space;
    onSeeAllGroupClick();
    return history.push(
      createResourceLocatorString(
        'DiscoverGroupsCommunityPage',
        routeConfiguration,
        { id, slug },
        {}
      )
    );
  };
  return (
    <>
      <Modal
        id="seeAllGroupModal"
        isOpen={isSeeAllGroup}
        onClose={onSeeAllGroupClick}
        onManageDisableScrolling={manageDisableScrolling}
        className={css.seeAllModal}
      >
        <div className={css.seeAllWrapper}>
          {Array.isArray(spaceListData)
            ? spaceListData
              ?.filter(item => !item.is_member) //THQ-203 point 2.(a)

              .map(item => (
                <div className={css.seeall} key={item.id} onClick={() => fetchSpaceDetails(item)}>
                  <ProfileIconCard type="purple" />
                  <span>{item.name}</span>
                </div>
              ))
            : null}
        </div>
      </Modal>
    </>
  );
};

export default SeeAllGroupModal;
